import { factPanelIdentifier } from '../common/constants';
import { Image } from '../common/model';

export const findFactPanelImage = (images?: Image[]): Image | undefined =>
	images?.find(image => factPanelIdentifier.test(image.side));
